import angular from "angular";
import SamoodpocetBatchCtrl from "./SamoodpocetBatchCtrl";

export default angular.module("energis.samoodpocet", [])
.config(function routing($urlRouterProvider, $locationProvider, $stateProvider) {
  //$locationProvider.html5Mode(true);
  $urlRouterProvider.otherwise('/');
  $stateProvider
  .state("samoodpocet-hromadne-plyn",{
    url:"/samoodpocet/plyn",
    template: require("./samoodpocet.plyn.html"),
    controller: SamoodpocetBatchCtrl,
    controllerAs: "ctrl",
    resolve: {
      typOM: () => "PLYN"
    }
  })
  .state("samoodpocet-hromadne-elektrina",{
    url:"/samoodpocet/elektrina",
    template: require("./samoodpocet.elektrina.html"),
    controller: SamoodpocetBatchCtrl,
    controllerAs: "ctrl",
    resolve: {
      typOM: () => "EE"
    }
  })
})
.name


// WEBPACK FOOTER //
// ./src/Samoodpocet/index.js